import React from "react";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Modal = styled.div`
  background: white;
  padding: 32px;
  border-radius: 8px;
  max-width: calc(94% - 32px - 40px);
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  @media (min-width: 768px) {
    max-width: 400px;
  }
`;

const Title = styled.h2`
  margin-bottom: 16px;
  color: var(--text-100);
`;

const Text = styled.p`
  margin-bottom: 24px;
  color: var(--text-200);
  font-size: 16px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background: var(--success-color);
  color: var(--bg-100);
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s ease;
  width: 50%;
  margin: 0 auto;
  &:hover {
    background: var(--success-color);
    color: var(--text-300);
  }
`;

const NotApprovedModal = ({ onClose }) => {
  return (
    <Backdrop>
      <Modal>
        <Title>Almost there!</Title>
        <Text>
          Your account is under review. Please be patient – an admin will
          approve your access soon. Thank you!
        </Text>
        <Button onClick={onClose}>OK</Button>
      </Modal>
    </Backdrop>
  );
};

export default NotApprovedModal;
